import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=b7d1cc8c&scoped=true&"
import script from "./ToggleButton.vue?vue&type=script&lang=ts&"
export * from "./ToggleButton.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleButton.vue?vue&type=style&index=0&id=b7d1cc8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d1cc8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
